import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NewssoappSharedModule } from 'app/shared';
import { selfServiceState } from './self-service.route';
import { HomepageComponent } from './components/homepage/homepage.component';
import { ChangePinComponent } from './components/change-pin/change-pin.component';
import { ChangePasswordComponent } from './components/change-password/change-password.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { ForgotUsernameComponent } from './components/forgot-username/forgot-username.component';
import { EditAccountInfoComponent } from './components/edit-account-info/edit-account-info.component';
import { JhiLanguageHelper } from 'app/core';
import { CustomBoxComponent } from './components/custom-box/custom-box.component';
import { CustomInputComponent } from './components/custom-input/custom-input.component';
import { VerifyOtpComponent } from 'app/layouts/homepage/components/verify-otp/verify-otp.component';
import { FirstLoginComponent } from './components/first-login/first-login.component';
import { DataSharingService } from 'app/layouts/homepage/services/data-sharing.service';
import { DigitsOnlyDirective } from './directives/digits-only.directive';
import { LaddaModule } from 'app/layouts/homepage/directives/ladda.module';
import { ContentLoaderModule } from 'app/layouts/homepage/components/content-loader/content-loader.module';
import { NotAllowedOrganizationComponent } from './components/not-allowed-organization/not-allowed-organization.component';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslateModule } from '@ngx-translate/core';
import { ErrorComponent } from './components/error/error.component';

@NgModule({
    imports: [
        NewssoappSharedModule,
        LaddaModule.forRoot({
            style: 'contract',
            spinnerSize: 30,
            spinnerColor: 'white',
            spinnerLines: 12
        }),
        ContentLoaderModule,
        RouterModule.forChild(selfServiceState),
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        NgbModule,
        InfiniteScrollModule,
        FontAwesomeModule,
        ReactiveFormsModule,
        TranslateModule
    ],
    declarations: [
        CustomBoxComponent,
        HomepageComponent,
        ChangePasswordComponent,
        ChangePinComponent,
        ForgotPasswordComponent,
        ForgotUsernameComponent,
        EditAccountInfoComponent,
        CustomInputComponent,
        VerifyOtpComponent,
        FirstLoginComponent,
        DigitsOnlyDirective,
        NotAllowedOrganizationComponent,
        ErrorComponent
    ],
    providers: [DataSharingService],
    exports: [CustomBoxComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class NewssoappSelfServiceModule {
    constructor(private languageHelper: JhiLanguageHelper) {
        this.languageHelper.language.subscribe((languageKey: string) => {
            if (languageKey !== undefined) {
                // this.languageService.changeLanguage(languageKey);
            }
        });
    }
}
